
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { PageBase } from 't4core';
import { ActivityPeriodSummary, DateValue, RentalInfo, RentalKPI, T4ListItem } from 't4core';


export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  styleUrls: ['./settlementSummary.css'],
  selector: 'u4f-settlementSummary',
  templateUrl: './settlementSummary.html',
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class SettlementSummaryComponent extends PageBase implements OnInit {

  private _fromDate: Moment = moment().startOf('month').add(-3, 'month');
  private _toDate: Moment = moment().subtract(1, 'month').endOf('month');
  public queryParameters: any = { from: this._fromDate.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._toDate.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "U4F_ExecutiveSummary" };
  public get fromDate(): Moment { return this._fromDate; }
  public set fromDate(value: Moment) {
    if (this._fromDate != value) {
      this._fromDate = value;
      this.queryParameters = { from: this._fromDate.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._toDate.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "U4F_ExecutiveSummary" };
    }
  }
  public get toDate(): Moment { return this._toDate; }
  public set toDate(value: Moment) {
    if (this._toDate != value) {
      this._toDate = value;
      this.queryParameters = { from: this._fromDate.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._toDate.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "U4F_ExecutiveSummary" };
    }
  } 

  public updateParams() {
    this.queryParameters = { from: this._fromDate.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._toDate.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "U4F_ExecutiveSummary" };
  }

  constructor(el: ElementRef) {
    super(el, "Use4FreeModule");
  }

  public async ngOnInit() {
    this.loadData();
  }

  public async loadData() {
    this.fromDate = this.fromDate.clone();

    const today = moment();
    if (this.toDate.isSame(today, 'month') && this.toDate.year() === today.year()) {
      this.toDate = today;
    }

    this.updateParams();
  }

  public rentalLocationGroupChanged(rentalLocationGroup: T4ListItem) {
    this.loadData();
  }

  public sumOfRevenueShare(data: any[]): number {
    return data.reduce((sum, i) => sum + i.RevenueShare, 0);
  }

  public sumOfRevenueShareInsurance(data: any[]): number {
    return data.reduce((sum, i) => sum + i.RevenueShare_Insurance, 0);
  }

  public sumOfRevenueShareOthers(data: any[]): number {
    return data.reduce((sum, i) =>
      sum + ((i.RevenueShare || 0) - (i.RevenueShare_Insurance || 0)), 0);
  }

  public sumOfNetCost(data: any[]): number {
    return data.reduce((sum, i) => sum + i.NetCostAfterRevenueShare, 0);
  }

  public sumOfTotalCost(data: any[]): number {
    return data.reduce((sum, i) => sum + i.TotalCostOfTrailers, 0); 
  }

  public sumOfDiscount(data: any[]): number {
    return data.reduce((sum, i) => sum + i.RevenueShare, 0) / data.reduce((sum, i) => sum + i.TotalCostOfTrailers, 0);
  }

  public sumOfTotalTurnOver(data: any[]): number {
    return data.reduce((sum, i) => sum + i.TotalTurnOver, 0);
  }
}
